'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiArrowMaximiseOutline = function TiArrowMaximiseOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.7 5h-8.8c-2.1 0-4 1.4-4.7 3.3h-11.5v11.8c0 0.1 0 0.1 0 0.2-2 0.7-3.4 2.5-3.4 4.7v11.7h11.7c2.2 0 4.3-1.4 5-3.4h11.7v-11.7c0-0.1 0-0.2 0-0.2 1.9-0.7 3.3-2.6 3.3-4.7v-11.7h-3.3z m-3.4 25h-8.3c-0.9 0-1.7-0.7-1.7-1.7s0.8-1.6 1.7-1.6h5v-5.1c0-1 0.7-1.7 1.7-1.7s1.6 0.7 1.6 1.7v8.4z m-18.3-18.3h8.4c1 0 1.7 0.7 1.7 1.6s-0.7 1.7-1.7 1.7h-5.1v5.1c0 0.9-0.7 1.7-1.6 1.7-1 0-1.7-0.8-1.7-1.7v-8.4z m21.7 5c0 0.9-0.8 1.6-1.7 1.6s-1.7-0.7-1.7-1.6v-2.7l-5.5 5.5c-0.3 0.3-0.7 0.5-1.1 0.5s-0.9-0.2-1.2-0.5c-0.7-0.6-0.7-1.7 0-2.3l5.5-5.5h-2.7c-0.9 0-1.6-0.8-1.6-1.7s0.7-1.7 1.6-1.7h8.4v8.4z m-16.7 16.6h-8.3v-8.3c0-0.9 0.7-1.7 1.6-1.7s1.7 0.8 1.7 1.7v2.6l5.5-5.4c0.3-0.4 0.7-0.5 1.2-0.5s0.8 0.1 1.1 0.5c0.7 0.6 0.7 1.7 0 2.3l-5.4 5.5h2.6c0.9 0 1.7 0.7 1.7 1.7s-0.8 1.6-1.7 1.6z m4-12.3c-0.6-0.7-1.4-1-2.3-1-0.6 0-1.2 0.2-1.7 0.5 0-0.1 0-0.3 0-0.4v-3.4h3.4c0.2 0 0.3-0.1 0.4-0.1-0.3 0.5-0.5 1.1-0.5 1.7 0 0.9 0.4 1.8 1 2.4s1.5 1 2.4 1c0.6 0 1.2-0.2 1.7-0.5 0 0.1-0.1 0.2-0.1 0.4v3.4h-3.2c-0.2 0-0.4 0-0.6 0.1 0.3-0.6 0.5-1.1 0.5-1.8 0-0.9-0.3-1.7-1-2.3z' })
        )
    );
};

exports.default = TiArrowMaximiseOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/arrow-maximise-outline.js
// module id = 3526
// module chunks = 0